import { useState, useEffect } from 'react'
import { useField } from 'formik'

import { useUser } from 'Services/User'
import { isofetch } from 'Services/Fetch'

import Heading from 'components/Heading'
import Button from 'components/Button'

import { EmailField, PasswordField } from 'components/Fields'

import RightArrow from 'public/icons/rightarrow.svg'

import styles from '../Signup.module.css'

const LoginForm = (props) => {
  const {
    formField: { email, password },
  } = props

  const [email_field, email_meta, email_helpers] = useField(email.name)
  const [password_field, password_meta, password_helpers] = useField(password.name)
  const { signIn } = useUser()
  const [errorMessage, setErrorMessage] = useState()

  async function login() {
    setErrorMessage(false)
    if (email_field.value == '') {
      await email_helpers.setError('Email is required')
    }

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email_field.value)) {
      await email_helpers.setError('Email is invalid')
    }

    if (password_field.value == '') {
      await password_helpers.setError('Password is required')
    }

    if (props.errors) {
      return false
    }

    const response = await isofetch('/api/auth/signin', 'POST', {
      email: email_field.value,
      password: password_field.value,
    })

    props.setSubmitting(false)
    if (response.success) {
      signIn({
        id: response.id,
        email: response.email,
        first_name: response.first_name,
        last_name: response.last_name,
      })
    } else {
      setErrorMessage(response.message)
    }
  }

  async function submit() {
    await props.setFieldValue('step', 'login')
    props.handleSubmit()
  }

  return (
    <div className={styles['step-wrapper']}>
      <Heading element="h3" bold center>
        You already have a TITANS of CNC account!
      </Heading>
      <div className={styles['create-account-wrapper']}>
        <div className={styles['signup-fields']}>
          <div className={styles['signup-field-email']}>
            <EmailField name={email.name} label={email.label} className={styles['signup-input']} />
          </div>
          <div className={styles['signup-field-password']}>
            <PasswordField name={password.name} label={password.label} className={styles['signup-input']} />
          </div>
        </div>

        <div className={styles['form-footer']}>
          {errorMessage && <div className={styles['error']} dangerouslySetInnerHTML={{ __html: errorMessage }} />}
          <Button onClick={login} primary centered disabled={props.isSubmitting} spinner={props.isSubmitting}>
            Next
          </Button>
        </div>
      </div>
    </div>
  )
}

export default LoginForm
